/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { 
    GET_MIGRATION_STATUS_FETCHING,
    GET_MIGRATION_STATUS_SUCCESS,
    GET_MIGRATION_STATUS_ERROR,
    GET_UPDATED_CODES_SUCCESS
} from 'state/actions/commentingState/advancedStatus';


/* ========== ~~~~~~~~~~  CONFIG : REDUCER ~~~~~~~~~~ ========== */
//transpiler


// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = {
    isError: false,
    isFetching: false,
    migrationStatus: null,
    codes: {
        commentingUnitCode: {
            headerCode: '',
            bodyCode: ''
        },
        communityCode: { code: '' },
        commentsCounterCode: { bodyCode: ''}
    }
};


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
const advancedStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case GET_MIGRATION_STATUS_FETCHING:
            newState.isFetching = action.data
            return newState;
        case GET_MIGRATION_STATUS_SUCCESS:
            newState.migrationStatus = action.data;
            return newState;
        case GET_MIGRATION_STATUS_ERROR:
            newState.isError = true;
            return newState;
        case GET_UPDATED_CODES_SUCCESS:
            newState.codes = action.data;
            return newState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default advancedStatus;
